import React from 'react';

// Public account-deletion page: Google Play requires a web URL where users can
// request deletion without reinstalling the app (Data safety form).
const DeleteAccount: React.FC = () => {
  return (
    <div style={{
      fontFamily: "'Roboto', sans-serif",
      maxWidth: '1100px',
      margin: '40px auto',
      padding: '20px 40px',
      lineHeight: 1.7,
      color: '#333',
      backgroundColor: '#fff',
      minHeight: '100vh',
      textAlign: 'left'
    }}>
      <h1 style={{
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '1.8em',
        marginBottom: '30px'
      }}>Delete your CruxLabs account</h1>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>From the app</h2>
      <ol style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>Open the CruxLabs app and sign in.</li>
        <li style={{ marginBottom: '0.5em' }}>Open <strong>More</strong>, then <strong>App settings</strong>.</li>
        <li style={{ marginBottom: '0.5em' }}>Tap <strong>Delete my account</strong> and confirm.</li>
      </ol>
      <p style={{ marginBottom: '1.2em' }}>Your account is deleted immediately.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>Without the app</h2>
      <p style={{ marginBottom: '1.2em' }}>
        Email <a href="mailto:contact@cruxlabs.app?subject=Account%20deletion%20request" style={{ color: '#0275d8' }}>contact@cruxlabs.app</a> from
        the address linked to your account, with the subject "Account deletion request". We delete the account within 30 days
        and confirm by email.
      </p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>What is deleted</h2>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>Your account: username, email, profile information and sign-in links (Google, Apple).</li>
        <li style={{ marginBottom: '0.5em' }}>Your favorites, climbing logs and votes on warnings.</li>
        <li style={{ marginBottom: '0.5em' }}>The warnings you posted on 3D models.</li>
      </ul>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>What is kept</h2>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>Scan data you contributed to build 3D models is kept, detached from your account.</li>
        <li style={{ marginBottom: '0.5em' }}>Server backups may retain deleted data for up to 30 days before being overwritten.</li>
      </ul>
    </div>
  );
};

export default DeleteAccount;
